export default __webpack_public_path__ + "static/media/telenor.7e83c567.png";